import { Button } from '@nextui-org/react'
import { FC } from 'react'
import useHomeAddBatchStore from '../../store/home/useHomeAddBatchStore'
import { useAddBatch } from '../../hooks/useAddBatch'

type SelectTanksAddBatchButtonProps = {
  onClose: () => void
  onOpen: () => void
}

export const SelectTanksAddBatchButton: FC<SelectTanksAddBatchButtonProps> = ({
  onClose,
  onOpen,
}) => {
  const {
    setNameBorderColor,
    setDateBorderColor,
    setSelectedTanksBorderColor,
    tanksValues,
    batchName,
    startDate,
    selectedTanks,
    nameDuplicated,
  } = useHomeAddBatchStore()
  const addBatchMutation = useAddBatch()

  const checkTanksBeforeContinue = () => {
    setNameBorderColor()
    setDateBorderColor()
    setSelectedTanksBorderColor()
    if (
      tanksValues &&
      batchName &&
      !batchName.includes('$') &&
      startDate &&
      selectedTanks.length !== 0 &&
      !nameDuplicated
    ) {
      if (tanksValues.emptyTanks.length !== 0) {
        onClose()
        onOpen()
      } else {
        addBatchMutation.mutate(tanksValues, {
          onSuccess: () => {
            onClose()
          }
        })
      }
    }
  }

  return (
    <>
      <Button
        className="font-bold text-white w-[6rem] mr-0 bg-tdplplum"
        onPress={checkTanksBeforeContinue}
        data-testid="continue-button"
      >
        Continue
      </Button>
    </>
  )
}
